angular.module('wco.directives.packageInfo', [])
.directive('wcoPackageInfo', ['numberFormatService', function(numberFormatService) {
    return {
        templateUrl: function(element, attrs) {
            return attrs.templateUrl || 'angular/directives/packageInfo.html';
        },
        replace: true,
        link: function(scope, element, attrs, ngModelController) {
            let keyboardPosition = {
                of: $('.keyboard-container'),
                my : 'center top',
                at : 'center top',
                at2: 'center bottom'
            };

            $(element).find('.package-text-input').keyboard({
                layout: 'customwebco',
                autoAccept : true,
                position: keyboardPosition
            }).previewKeyset({
                sets : [ 'normal', 'shift', 'alt', 'alt-shift' ]
            });

            $(element).find('.package-number-input').keyboard({
                layout: 'customnum',
                autoAccept : true,
                position: keyboardPosition
            });
        }
    };
}]);